import type { ActionType } from 'sharedreact/actions/generic/actions';
import AppDispatcher from 'sharedreact/dispatcher/AppDispatcher';
import ItemsState from 'sharedreact/stores/generic/ItemsState';
import PaginatedItemsStore from 'sharedreact/stores/generic/PaginatedItemsStore';
import AuditRecord from 'sharedreact/data/AuditRecord';
import SortOrder from 'sharedreact/data/SortOrder';

import AuditActions from 'workspaces/launcher/actions/AuditActions';
import AuditConstants from 'workspaces/launcher/constants/AuditConstants';

class AuditStore extends PaginatedItemsStore<AuditRecord> {
  constructor () {
    super(AppDispatcher, AuditActions, AuditConstants);
  }

  getFilterKeywords (): string[] {
    return ['modificationdate', 'username'];
  }

  getSortKeywords (): string[] {
    return ['modificationdate', 'username'];
  }

  getInitialSortOrder (): SortOrder {
    return new SortOrder({keyword: 'modificationdate', ascending: false});
  }

  getSecondarySortKeyword (): string {
    return 'modificationdate';
  }

  getItemKeyForKeyword (keyword: string): string {
    switch (keyword) {
      case 'username': {
        return 'userName';
      }
      case 'modificationdate': {
        return 'modificationDate';
      }
      default: {
        break;
      }
    }
    return keyword;
  }

  override reduce (state: ItemsState<AuditRecord | null>, action: ActionType): ItemsState<AuditRecord | null> {
    switch (action.actionType) {
      case AuditConstants.REFRESH: {
        return this._refresh(state);
      }
    }

    return super.reduce(state, action);
  }
}

export default new AuditStore();
